package frontend.pages

import androidx.compose.runtime.*
import components.TButtonWide
import components.TTextInput
import frontend.App
import frontend.components.RoundedForm
import frontend.lib.LocalString.LoginEmpty
import frontend.lib.LocalString.PasswordEmpty
import frontend.lib.classList
import kotlinx.coroutines.launch
import net.sergeych.ugdx.GuestAPI
import org.jetbrains.compose.web.dom.*

@Composable
fun SignInUI(app: App, toggle: () -> Unit) {
    val scope = rememberCoroutineScope()
//    var login: String? by mutableStateOf(null)
//    var password: String? by mutableStateOf(null)
//    var login: String? by mutableStateOf("anzhu")
//    var login: String? by rememberState(app.storage, "signin_login", "")
    var login: String? by mutableStateOf(app.searchParams().get("l"))
    var password: String? by mutableStateOf("")
    var isLoading: Boolean by mutableStateOf(false)
    var error: String? by mutableStateOf(null)

    suspend fun signIn(login: String?, password: String?) {
        isLoading = true

        error = when {
            login == null -> LoginEmpty.t
            password == null -> PasswordEmpty.t
            else -> {
                if (GuestAPI().signIn(login, password) != null)
                    null
                else
                    "Invalid login and/or password"
            }
        }

        isLoading = false
    }

    Div(attrs = {
        classList("fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-800")
    }) {

        Div(
            attrs = {
                classes("min-h-full", "flex", "flex-col", "justify-center", "py-12", "sm:px-6", "lg:px-8")
            }
        ) {
            Div(attrs = { classes("sm:mx-auto", "sm:w-full", "sm:max-w-md") }) {
                H2(attrs = { classes("mt-6", "text-center", "text-3xl", "font-extrabold", "text-white") }) {
                    Text("Sign in to your account")
                }
                P(attrs = { classes("mt-2", "text-center", "text-sm", "text-white") }) {
                    Text("Or ")
                    A("javascript:void(0);", attrs = {
                        classes("font-medium", "text-indigo-600", "hover:text-indigo-500")
                        onClick { toggle() }
                    }) {
                        Text("sign up")
                    }
                }
            }

            RoundedForm() {
                TTextInput("login", login ?: "") {
                    onInput { login = it }
                    label { Text("Login") }
                }

                TTextInput("password", password ?: "") {
                    password()
                    onInput { password = it }
                    label { Text("Password") }
                }

                if (error != null)
                    P(attrs = { classes("text-red-600") }) { Text(error ?: "") }

                TButtonWide(attrs = {
                    onClick { scope.launch { signIn(login, password) } }
                    isLoading(isLoading)
                }) { Text("Login") }
            }
        }
    }
}